export default "__VITE_ASSET__BaH3mpS2__"